import * as LDClient from "launchdarkly-js-client-sdk";

export const initializeLDClient = (userInfo = {}, oid = null, slug = null) => {
	const clientSideKey = window.config.launchDarklyThankViewClientKey;

	const userContext = {
		kind: "user",
		key: userInfo.key || "anonymous",
		name: userInfo.name,
		email: userInfo.email,
	};

	const orgKey = oid || "unknown-org";
	const organizationContext = {
		kind: "organization",
		key: orgKey,
	};

	const slugKey = slug || "unknown-slug";
	const slugContext = {
		kind: "slug",
		key: slugKey,
	};

	const multiContext = {
		kind: "multi",
		user: userContext,
		organization: organizationContext,
		slug: slugContext,
	};

	return LDClient.initialize(clientSideKey, multiContext);
};
